<template>
  <div id="sideBar">
    <div class="py-3">
      <img src="/Images/logo-white.png" alt="Logo" />
    </div>
    <br />
    <ul>
      <li>
        <router-link to="posts">
          <div
            class="
              transition
              text-center text-xs text-gray-100
              py-3
              hover:bg-gray-100 hover:text-gray-900
            "
          >
            <i class="text-lg  fa fa-user"></i>
            <br />
            <span>Users</span>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="posts">
          <div
            class="
              transition
              text-center text-xs text-gray-100
              py-3
              hover:bg-gray-100 hover:text-gray-900
            "
          >
            <i class="text-lg  fa fa-rss"></i>
            <br />
            <span>Posts</span>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="blogs">
          <div
            class="
              transition
              text-center text-xs text-gray-100
              py-3
              hover:bg-gray-100 hover:text-gray-900
            "
          >
            <i class="text-lg  fa fa-rss"></i>
            <br />
            <span>Blogs</span>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="staffs">
          <div
            class="
              transition
              text-center text-xs text-gray-100
              py-3
              hover:bg-gray-100 hover:text-gray-900
            "
          >
            <i class="text-lg  fa fa-user"></i>
            <br />
            <span>Staff</span>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="posts">
          <div
            class="
              transition
              text-center text-xs text-gray-100
              py-3
              hover:bg-gray-100 hover:text-gray-900
            "
          >
            <i class="text-lg  fa fa-images"></i>
            <br />
            <span>Slides</span>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="posts">
          <div
            class="
              transition
              text-center text-xs text-gray-100
              py-3
              hover:bg-gray-100 hover:text-gray-900
            "
          >
            <i class="text-lg  fa fa-circle-info"></i>
            <br />
            <span>About</span>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="posts">
          <div
            class="
              transition
              text-center text-xs text-gray-100
              py-3
              hover:bg-gray-100 hover:text-gray-900
            "
          >
            <i class="text-lg  fa fa-circle-check"></i>
            <br />
            <span>Work<br />Principles</span>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="posts">
          <div
            class="
              transition
              text-center text-xs text-gray-100
              py-3
              hover:bg-gray-100 hover:text-gray-900
            "
          >
            <i class="text-lg  fa-solid fa-address-book"></i>
            <br />
            <span>Contact<br />Information</span>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="posts">
          <div
            class="
              transition
              text-center text-xs text-gray-100
              py-3
              hover:bg-gray-100 hover:text-gray-900
            "
          >
            <i class="text-lg  fa-solid fa-share-nodes"></i>
            <br />
            <span>Social<br />Media</span>
          </div>
        </router-link>
      </li>
      <li>
        <a @click="logOut">
          <div
            class="
              transition
              text-center text-xs text-gray-100
              py-3
              hover:bg-gray-100 hover:text-gray-900
            "
          >
          <i class=" text-lg fa-solid fa-arrow-right-from-bracket"></i>
           
            <br />
            <span>log out</span>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  methods:{
    logOut(){
      this.$store.dispatch("logOut")
    }
  }
};
</script>

<style>
</style>